function availabilityInformation(item, excludingRemote) {
  const counts = item.capacity_counts;

  // For attendance counts, suffix is "excluding_remote" rather than just
  // "in_person" to clarify that, should someone somehow get registered without
  // specifying in-person/remote, they will be included in the count, like an
  // in-person registration. It really means "in person", but technically
  // includes anything that isn't explicitly marked as remote.

  // However, people on a waiting list are termed to be "waiting_for_in_person"
  // because that is the more appropriate terminology for reflecting their
  // intent and there is no possibility of confusion in this context with
  // something that isn't explicitly marked as remote or not.
  const suffix = excludingRemote ? "_excluding_remote" : "";
  const waitingField = "waiting" + (excludingRemote ? "_for_in_person" : "");

  const fieldValue = (object, field) => object[field + suffix];

  const taken =
    (fieldValue(counts, "confirmed") ?? 0) +
    (fieldValue(counts, "pending") ?? 0);

  const waitingListPositionApplicable = excludingRemote
    ? counts.people_ahead_are_for_in_person
    : item.item_type === "attendance"
    ? !counts.people_ahead_are_for_in_person
    : true;

  const reservedBeforeMe =
    taken +
    ((waitingListPositionApplicable ? counts.people_ahead_on_waitlist : null) ??
      counts[waitingField] ??
      0);

  const reserved = taken + (counts[waitingField] ?? 0);

  const totalAvailable = fieldValue(item, "total_available") ?? Infinity;
  return {
    total: totalAvailable,
    toAnyone: Math.max(0, totalAvailable - reserved),
    toMe: Math.max(0, totalAvailable - reservedBeforeMe),
  };
}

export function capacityInformation(item) {
  const { capacity_counts } = item;

  const waitingList = {
    length: capacity_counts.waiting ?? 0,
    lengthForInPerson: capacity_counts.waiting_for_in_person ?? 0,
    position: capacity_counts.people_ahead_on_waitlist ?? null,
    positionIsForInPerson: capacity_counts.people_ahead_are_for_in_person,
  };
  const available = availabilityInformation(item, false);
  const availableExcludingRemote = availabilityInformation(item, true);
  return { waitingList, available, availableExcludingRemote };
}

export default capacityInformation;
